<template>
  <div class="ArtistRepresentativeMenuWrapper">
    <span class="title">{{ $t("band.RPMenu.subtitle") }}</span>
    <div v-if="bandSetLength > 1">
      <div class="pictures">
        <band_pill
          v-for="band in sortedBands.slice(0, 4)"
          v-if="band.id !== currentBand"
          :key="band.id"
          :band="band"
          :notifications="
            band_notif_meta[band.id] ? band_notif_meta[band.id].count : 0
          "
        />
      </div>
    </div>
    <div class="bottomContent">
      <span class="count"
        >{{ bandSetLength }}
        {{ $tc("band.RPMenu.count", bandSetLength) }} ·</span
      >
      <nuxt-link :to="'/band/profile/select/'" @click.native="$emit('close')">
        <span class="all">{{ $t("band.RPMenu.all") }}</span>
      </nuxt-link>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex"

import band_pill from "./bandPill"

import band_has_notif from "~/mixins/band/band_has_notif"
import select_delete_mixin from "~/mixins/band/profile/select_delete"

export default {
  components: { band_pill },
  mixins: [band_has_notif, select_delete_mixin],
  data: function () {
    return {
      band_notif_meta: {},
    }
  },
  mounted: async function () {
    this.$set(this, "band_notif_meta", await this.getBandNotifNumber())
  },
  computed: {
    sortedBands: function () {
      return this.sort_set_by_notif({
        band_set: this.bands,
        notif_standing: this.band_notif_meta,
      })
    },
    ...mapState({
      currentBand: (state) => state.user.band.id,
    }),
    ...mapGetters({
      bands: "user/band_set/LIVE_BANDS",
    }),
    bandSetLength: function () {
      return this.bands.length
    },
  },
}
</script>
<style scoped>
.ArtistRepresentativeMenuWrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  color: var(--color-black);
  font-size: var(--font-size-title-micro);
  font-weight: 500;
  font-family: EuclidFlex;
}

.subtitle {
  font-size: var(--font-size-small);
  color: var(--color-storm-grey);
}

.pictures {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
  position: relative;
}

.bottomContent {
  display: flex;
  align-items: center;
  margin-left: 0;
}
.count {
  color: var(--color-darker-grey);
  font-size: var(--font-size-small);
  margin-right: 2px;
}

.all {
  font-size: var(--font-size-small);
  color: var(--color-main);
  font-weight: 500;
  cursor: pointer;
}

@media screen and (min-width: 480px) {
  .title {
    font-size: var(--font-size-big);
  }
}
</style>
